module.exports = __webpack_public_path__ + "static/media/img-2.bad4a669.jpg";